module.exports = __webpack_public_path__ + "media/assets/community_index/expand-icon-15501f85f316a23a964cc42780126929776d480060606701f5175c64a724b6a2.svg";